<!-- eslint-disable -->
<template lang="pug">
    .game-content
        .games-wrapper
            .play-box
                game-header(
                    :to-settings-route="{name: 'abacus:settings'}",
                    @soundStateChanged="headerKey = !headerKey",
                    :key="headerKey",
                )
                .play-box__input
                    cs-input(
                        type="number"
                        ref="input"
                        required
                        maxlength="3"
                        v-model="inputNumber"
                    )
                cs-button.play-box__button(color="green", pattern="primary-outline", @click="changeCurrentNumber(0)")
                    | {{ $i18n.t('trainer.trainer_gamePlayBox_resetToZero') }}
                .play-box__abacus(v-if="currentNumber !== null")
                    abacus(
                        :number="currentNumber"
                        :game-settings="game"
                        :number-of-spokes="game.numberOfSpokes"
                        @number="changeCurrentNumber"
                    )
</template>

<script>
    /*eslint-disable*/
    import Abacus from './Abacus.vue'
    import {mapState} from 'vuex'
    import MobileDetect from 'mobile-detect'
    import GameHeader from '../../trainer/GameHeader.vue'

    export default {
        data () {
            return {
                parameters: null,
                inputNumber: null,
                currentNumber: null,
                isMobile: false,
                windowWidth: 0,
                windowHeight: 0,
                headerKey: false
            }
        },
        components: {
            GameHeader,
            Abacus
        },
        watch: {
            inputNumber (val) {
                if (val) {
                    this.currentNumber = Number(val)
                } else if (val === '') {
                    this.currentNumber = 0
                }
            }

        },
        beforeDestroy () {
            window.removeEventListener('resize', this.getWindowDimensions)
        },
        created () {
            let mobileDetect = new MobileDetect(window.navigator.userAgent)
            this.isMobile = !!(mobileDetect.phone() || mobileDetect.tablet() || mobileDetect.mobile())
            window.addEventListener('resize', this.getWindowDimensions)
            this.$nextTick(this.getWindowDimensions)
        },
        mounted () {
            if (this.game) {
                this.parameters = _.cloneDeep(this.game)
                this.$store.dispatch('setGame', _.cloneDeep(this.parameters))
            } else {
                this.$router.push({name: 'dashboard'})
            }
            this.currentNumber = 0
        },
        methods: {
            changeCurrentNumber (val) {
                this.inputNumber = val
                this.currentNumber = val
            },
            getWindowDimensions () {
                this.windowWidth = document.documentElement.clientWidth
                this.windowHeight = document.documentElement.clientHeight
            },
        },
        computed: {
            ...mapState({
                game: state => state.trainer.game
            }),
            isFullWidth () {
                return this.windowWidth >= this.windowHeight || this.windowWidth > 1000
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/main.scss";

    .games-wrapper {
        margin: 0;
        padding: 15px 20px;
        height: 100%;
        width: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    @import "@/assets/sass/games/playbox.scss";

    .play-box {
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
    }

    .play-box__input {
        display: flex;
        justify-content: center;
        @include media($sm) {
            margin-top: 80px;
        }
    }

    .play-box__input .cs-input {
        margin-bottom: 0;
        padding: 9px 15px;
        font-size: 28px;
        line-height: 50px;
        text-align: center;
        max-width: 260px;
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
            appearance: none;
            margin: 0;
        }

        @include media($sm) {
            font-size: 44px;
            line-height: 57px;
            max-width: 400px;
        }

        @include media($lg) {
            font-size: 52px;
            line-height: 62px;
            max-width: 450px;
        }
    }

    .play-box__button {
        margin: 45px 0;
        @include media($sm) {
            margin: 30px 0;
        }
    }

    .play-box__abacus {
        margin-bottom: 30px;
    }
</style>
